import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class HillyRoadTileEntity extends TileEntity {
	public static readonly frameName = FrameName.HILLY_ROAD;
}

export default HillyRoadTileEntity;
